<template>
    <v-dialog v-model="dialog" max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                       <span>edit channel</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New  parameters of <span class="secondary--text">{{ channel.name }}</span> of the 
                <span class="secondary--text">{{ channel.team.name }}</span> team
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent>
                        <v-row>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field dense color="secondary" 
                                    v-model="trademarks" 
                                    item-color="secondary" 
                                    label="trademarks"
                                    @change="onceMore()" 
                                    readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field dense color="secondary" 
                                    label="stores" 
                                    v-model.number="stores" 
                                    name="stores"
                                    type="text" 
                                    :readonly="readonly" 
                                    :rules="[rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="8">
                                <v-text-field dense color="secondary" 
                                    label="channel name" 
                                    v-model="name" name="name"
                                    type="text"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" 
                    :disabled="!valid || Boolean(error)"
                    @click="editChannel">Save</v-btn>
            </v-card-actions>
        </v-card>
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: 'EditChannel',
    props: ['channel'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            haveBeenChanged: false,
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
            },
            name: this.channel.name,
            stores: this.channel.stores,  
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        readonly() {
            if (parseInt(this.channel.type) === 1) return true
            return false
        },
        trademarks() {
            const arr = this.channel.trademarks.map(item => item.name)
            return arr.join(' , ')
        },
    },
    methods: {

        onceMore() {
            this.error = ''
            this.haveBeenChanged = true
        },
        async editChannel() {
            if (this.$refs.form.validate()) {
                const chan = {
                    id: this.channel.id,
                    stores: this.stores,
                    name: this.name
                }
                console.log(chan)
                try {
                    //edit segment 
                    await this.$store.dispatch('editChannel', chan)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.haveBeenChanged = false
            this.name = this.channel.name
            this.stores = this.channel.stores
            this.trademark = this.channel.trademarks
        }
    }
}
</script>